import styled from 'styled-components';
import { normalizeHeight, normalizeWidth } from '../../utils/normalize';

export const ChatBoxContainer = styled.div`
  height: ${normalizeHeight(820)};
  width: ${normalizeWidth(340)};
  min-width: 340px;
  background-color: rgba(252, 252, 252, 1);
  border-radius: 16px;
  box-shadow: 0px 0px 14px 0px rgba(140, 135, 150, 0.6);
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
`;

export const BackIconWrapper = styled.div`
  cursor: pointer;
  align-items: center;
  display: flex;
  width: 24px;
  height: 24px;
`;

export const ChatBoxHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const SolicitationsText = styled.h1`
  font-size: ${normalizeHeight(12)};
  color: rgba(110, 48, 232, 1);
  align-self: flex-end;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;

export const HeaderTitle = styled.h1`
  font-size: ${normalizeHeight(16)};
  font-weight: 600;
  color: rgba(27, 27, 27, 1);
`;

export const InboxMessagesContainer = styled.div`
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
  position: absolute;
  bottom: 16px;
  width: calc(100% - 32px);
  background-color: white;
`;

export const MessageInput = styled.input`
  width: 100%;
  height: ${normalizeHeight(40)};
  border-radius: 8px;
  border: 0;
  padding: 8px;
  outline: none;
`;

export const SendButton = styled.h1`
  font-size: 12px;
  color: #6E30E8;
  cursor: pointer;
`;